import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
  useLocation,
} from "react-router-dom";

import {
  motion,
  AnimatePresence,
} from "framer-motion";

import {
  useTranslation,
} from "react-i18next";

import {
  logo,
  darkLogo,
} from "../../assets";

import ToggleLanguages from "../utils/ToggleLanguages";
import ToggleDark from "../utils/ToggleDark";

import {
  useStateContext,
} from "../../context/ContextProvider";

import Navebar from "./Navebar";
import Navmobile from "./Navmobile";

import {
  HiOutlineMenuAlt3,
  HiOutlineX,
} from "react-icons/hi";

import { FiShoppingBag } from "react-icons/fi";
import { useSelector } from "react-redux";
import OrderDrawer from "../order/OrderDrawer";
function Header({
  active,
  DropActive,
}) {
  const { t } = useTranslation();

  const location = useLocation();
  const [orderOpen, setOrderOpen] =
  useState(false);

const orderItems = useSelector(
  (state) =>
    state.Order?.items || []
);

const orderCount =
  orderItems.reduce(
    (total, item) =>
      total + item.quantity,
    0
  );
  const {
    currentMode,
  } = useStateContext();

  const [
    openNavigation,
    setOpenNavigation,
  ] = useState(false);

  const [
    isScrolled,
    setIsScrolled,
  ] = useState(false);


  /* =========================
     Scroll Detection
  ========================== */

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(
        window.scrollY > 30
      );
    };

    handleScroll();

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );
    };
  }, []);


  /* =========================
     Close Mobile Menu
     After Route Change
  ========================== */

  useEffect(() => {
    setOpenNavigation(false);
  }, [location.pathname]);


  /* =========================
     Disable Body Scroll
     When Mobile Menu Is Open
  ========================== */

  useEffect(() => {
    if (openNavigation) {
      document.body.style.overflow =
        "hidden";
    } else {
      document.body.style.overflow =
        "";
    }

    return () => {
      document.body.style.overflow =
        "";
    };
  }, [openNavigation]);


  const toggleNavigation = () => {
    setOpenNavigation(
      (prev) => !prev
    );
  };


  return (
    <>
      {/* =================================
          HEADER
      ================================= */}

      <motion.header
        initial={{
          y: -100,
          opacity: 0,
        }}
        animate={{
          y: 0,
          opacity: 1,
        }}
        transition={{
          duration: 0.65,
          ease: [0.22, 1, 0.36, 1],
        }}
        className={`
          fixed
          top-0
          start-0

          z-[999]

          w-full

          transition-all
          duration-500

          ${
            isScrolled
              ? "py-2"
              : "py-4 md:py-5"
          }
        `}
      >
        <div className="container">

          {/* =================================
              HEADER CONTAINER

              Mobile:
              Flex

              Desktop:
              3-column Grid
          ================================= */}

          <div
            className={`
              relative

              flex
              items-center
              justify-between

              lg:grid
              lg:grid-cols-[1fr_auto_1fr]
              lg:justify-normal

              px-4
              md:px-5
              lg:px-7

              rounded-[1.4rem]
              md:rounded-[1.65rem]
              lg:rounded-[1.75rem]

              border

              transition-all
              duration-500

              ${
                isScrolled
                  ? `
                    h-[68px]
                    sm:h-[72px]
                    md:h-[76px]

                    border-color-2/10
                    dark:border-white/10

                    bg-back-primery/95
                    dark:bg-back-darksecondary/95

                    backdrop-blur-2xl

                    shadow-[0_12px_35px_rgba(68,37,20,0.12)]
                  `
                  : `
                    h-[72px]
                    sm:h-[78px]
                    md:h-[84px]
                    lg:h-[86px]

                    border-white/15

                    bg-white/10
                    dark:bg-black/15

                    backdrop-blur-xl

                    shadow-[0_8px_30px_rgba(0,0,0,0.10)]
                  `
              }
            `}
          >

            {/* =========================
                Decorative Accent
            ========================== */}

            <div
              className={`
                absolute
                bottom-0
                start-6
                lg:start-7

                h-[2px]

                rounded-full

                bg-color-1

                transition-all
                duration-500

                ${
                  isScrolled
                    ? "w-10 lg:w-12"
                    : "w-14 lg:w-20"
                }
              `}
            />


            {/* =================================
                LOGO
            ================================= */}

            <div
              className="
                relative
                z-10

                flex
                items-center

                lg:justify-start

                shrink-0
              "
            >
              <Link
                to="/"
                onClick={() => {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });

                  setOpenNavigation(false);
                }}
                className="
                  flex
                  items-center
                  shrink-0
                "
              >
                <img
                  src={
                    currentMode ===
                    "Light"
                      ? logo
                      : darkLogo
                  }
                  alt={t(
                    "Yaman Restaurant"
                  )}
                  className={`
                    object-contain

                    transition-all
                    duration-500

                    ${
                      isScrolled
                        ? `
                          w-[76px]
                          sm:w-[82px]
                          md:w-[88px]
                          lg:w-[92px]
                        `
                        : `
                          w-[82px]
                          sm:w-[88px]
                          md:w-[98px]
                          lg:w-[108px]
                        `
                    }
                  `}
                />
              </Link>
            </div>


            {/* =================================
                DESKTOP NAVIGATION
            ================================= */}

            <div
              className="
                relative
                z-10

                hidden
                lg:flex

                items-center
                justify-center

                min-w-0
              "
            >
              <Navebar
                active={active}
                DropActive={DropActive}
                isScrolled={isScrolled}
              />
            </div>


            {/* =================================
                ACTIONS
            ================================= */}
{/* =================================
    ACTIONS
================================= */}

<div
  className="
    relative
    z-10

    flex
    items-center
    justify-end

    gap-2
    md:gap-3

    shrink-0
  "
>

  {/* =================================
      ORDER BUTTON
      يظهر في الهاتف والكمبيوتر
  ================================= */}

  <motion.button
    type="button"

    whileHover={{
      scale: 1.05,
    }}

    whileTap={{
      scale: 0.94,
    }}

    onClick={() => {
      setOpenNavigation(false);
      setOrderOpen(true);
    }}

    aria-label={t("your order")}

    className="
      relative

      flex

      w-10
      h-10

      sm:w-11
      sm:h-11

      md:w-12
      md:h-12

      shrink-0

      items-center
      justify-center

      rounded-full

      border
      border-color-1/25

      bg-color-1/10

      text-color-1

      transition-all
      duration-300

      hover:bg-color-1
      hover:text-white
    "
  >
    <FiShoppingBag
      size={19}
    />


    {/* Counter */}

    {orderCount > 0 && (
      <motion.span
        key={orderCount}

        initial={{
          scale: 0,
        }}

        animate={{
          scale: 1,
        }}

        className="
          absolute

          -top-1
          -end-1

          flex

          min-w-[20px]
          h-5

          items-center
          justify-center

          rounded-full

          bg-color-1

          px-1

          text-[10px]
          font-bold
          text-white

          ring-2
          ring-back-primery

          dark:ring-back-darksecondary
        "
      >
        {orderCount > 99
          ? "99+"
          : orderCount}
      </motion.span>
    )}

  </motion.button>


  {/* =================================
      LANGUAGE + DARK MODE
      مخفية فقط على الهاتف الصغير
  ================================= */}

  <div
    className="
      hidden
      sm:flex

      items-center

      gap-2
    "
  >

    {/* Language */}

    <div
      className={`
        flex

        items-center
        justify-center

        rounded-xl

        border

        p-1.5

        transition-all
        duration-300

        ${
          isScrolled
            ? `
              border-color-2/10
              dark:border-white/10

              bg-color-2/5
              dark:bg-white/5
            `
            : `
              border-white/15

              bg-white/10
            `
        }
      `}
    >
      <ToggleLanguages />
    </div>


    {/* Dark Mode */}

    <div
      className={`
        flex

        items-center
        justify-center

        rounded-xl

        border

        p-1.5

        transition-all
        duration-300

        ${
          isScrolled
            ? `
              border-color-2/10
              dark:border-white/10

              bg-color-2/5
              dark:bg-white/5
            `
            : `
              border-white/15

              bg-white/10
            `
        }
      `}
    >
      <ToggleDark />
    </div>

  </div>


  {/* =================================
      MOBILE MENU BUTTON
  ================================= */}

  <motion.button
    type="button"

    whileHover={{
      scale: 1.04,
    }}

    whileTap={{
      scale: 0.92,
    }}

    onClick={
      toggleNavigation
    }

    aria-label={
      openNavigation
        ? t(
            "close navigation"
          )
        : t(
            "open navigation"
          )
    }

    className="
      lg:hidden

      flex

      w-10
      h-10

      sm:w-11
      sm:h-11

      md:w-12
      md:h-12

      shrink-0

      items-center
      justify-center

      rounded-full

      border
      border-color-1/40

      bg-color-1

      text-white

      shadow-[0_8px_25px_rgba(165,119,58,0.30)]

      transition-colors
      duration-300

      hover:bg-color-2
    "
  >

    <AnimatePresence
      mode="wait"
      initial={false}
    >

      {openNavigation ? (

        <motion.span
          key="close"

          initial={{
            rotate: -90,
            opacity: 0,
            scale: 0.8,
          }}

          animate={{
            rotate: 0,
            opacity: 1,
            scale: 1,
          }}

          exit={{
            rotate: 90,
            opacity: 0,
            scale: 0.8,
          }}

          transition={{
            duration: 0.2,
          }}
        >
          <HiOutlineX
            size={22}
          />
        </motion.span>

      ) : (

        <motion.span
          key="menu"

          initial={{
            rotate: 90,
            opacity: 0,
            scale: 0.8,
          }}

          animate={{
            rotate: 0,
            opacity: 1,
            scale: 1,
          }}

          exit={{
            rotate: -90,
            opacity: 0,
            scale: 0.8,
          }}

          transition={{
            duration: 0.2,
          }}
        >
          <HiOutlineMenuAlt3
            size={22}
          />
        </motion.span>

      )}

    </AnimatePresence>

  </motion.button>

</div>
          </div>

        </div>
      </motion.header>


      {/* =================================
          MOBILE NAVIGATION
      ================================= */}

      <AnimatePresence>
        {openNavigation && (
          <Navmobile
            active={active}
            DropActive={DropActive}
            setOpenNavigation={
              setOpenNavigation
            }
          />
        )}
      </AnimatePresence>
      <OrderDrawer
  open={orderOpen}
  onClose={() =>
    setOrderOpen(false)
  }
/>
    </>
  );
}

export default Header;